import React from 'react';
import '../../css/Home.css'; // Adjusted path to import Home.css
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import Testimonial from "./Testimonial";
import TrustpilotWidget from "../js/TrustpilotWidget";
import Pitch from "./Pitch";
const Home = () => {
    return (
        <>
            <Helmet>
                <title>Psychology AI Clinical Notes Generator</title>
                <meta
                    name="description"
                    content="Use this application to generate psychology SOAP notes quick efficiently and effectively, saving time and enhancing accuracy."/>
                <meta name="description"
                      content="Automated psyschology SOAP notes generator for psychologists and therapists to streamline session documentation."/>
                <meta property="og:title" content="Streamlined Clinical Documentation for Psychologists"/>
                <meta property="og:description"
                      content="Use our AI-powered clinical notes generator to automate therapy session documentation."/>
                <meta name="twitter:title" content="Automated Psychology Clinical Notes Generator"/>
                <meta name="twitter:description"
                      content="Efficient AI tool for mental health professionals to document sessions."/>
                <link rel="canonical" href="https://api.affordablecustomehr.com/psychology-ai-notes-generator/"/>
            </Helmet>
            <div
                className="home flex flex-col items-center justify-center h-screen text-center px-4 sm:px-6 lg:px-8 space-y-4">
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
                    Psychology AI Clinical Notes Generator
                </h1>
                <p className="text-base sm:text-lg lg:text-xl max-w-2xl">
                    Use this application free to generate psychology notes efficiently and effectively, saving time and
                    enhancing accuracy.
                </p>
                <div className="home-page">
                    <p>Learn how to use the application by watching our training video below.</p>
                    <div className="video-container">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/sPem9b5T5ps"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <TrustpilotWidget/>
            <Testimonial/>
            <Pitch/>
            <footer className="footer-links">
                <Link to="/terms-of-service" className="tos-link">Terms of Service</Link>
                <span className="link-divider">|</span>
                <Link to="/privacy-policy" className="pp-link">Privacy Policy</Link>
                <span className="link-divider">|</span>
                <Link to="/disclaimer" className="dis-link">Disclaimer</Link>
                <span className="link-divider">|</span>
                <a href="https://www.tarevo.com/" className="dis-link">Tarevo</a>
            </footer>
        </>
    );
};

export default Home;

